var _path, _path2, _path3, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 74,
    viewBox: "0 0 58 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3344 28.8462C52.3344 41.6411 29.1672 65.8152 29.1672 65.8152C29.1672 65.8152 6 41.6411 6 28.8462C6 16.0513 16.3723 5.67896 29.1672 5.67896C41.9621 5.67896 52.3344 16.0513 52.3344 28.8462Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3344 28.8462C52.3344 41.6411 29.1672 65.8152 29.1672 65.8152C29.1672 65.8152 6 41.6411 6 28.8462C6 16.0513 16.3723 5.67896 29.1672 5.67896C41.9621 5.67896 52.3344 16.0513 52.3344 28.8462Z",
    fill: "url(#paint0_linear_4581_10667)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1672 65.8152L27.1666 67.7324L29.1672 69.82L31.1678 67.7324L29.1672 65.8152ZM29.1672 65.8152C31.1678 67.7324 31.1682 67.7321 31.1686 67.7316L31.1699 67.7303L31.174 67.7259L31.1886 67.7107L31.2424 67.6542C31.289 67.6051 31.3569 67.5335 31.4447 67.4403C31.6202 67.2539 31.8752 66.9814 32.1985 66.6313C32.8448 65.9314 33.7645 64.9209 34.8666 63.6694C37.0683 61.1694 40.0105 57.6936 42.9593 53.8024C45.9003 49.9214 48.8911 45.5707 51.1586 41.3261C53.3817 37.1648 55.1054 32.753 55.1054 28.8462C55.1054 14.5209 43.4925 2.90797 29.1672 2.90797C14.8419 2.90797 3.22902 14.5209 3.22902 28.8462C3.22902 32.753 4.95276 37.1648 7.1758 41.3261C9.44336 45.5707 12.4341 49.9214 15.3751 53.8024C18.3239 57.6936 21.2661 61.1694 23.4678 63.6694C24.57 64.9209 25.4897 65.9314 26.136 66.6313C26.4592 66.9814 26.7143 67.2539 26.8898 67.4403C26.9775 67.5335 27.0454 67.6051 27.092 67.6542L27.1458 67.7107L27.1604 67.7259L27.1646 67.7303L27.1659 67.7316C27.1663 67.7321 27.1666 67.7324 29.1672 65.8152Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 5.54196
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1583,
    cy: 28.2725,
    r: 13.6036,
    fill: "black",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4581_10667",
    x1: 29.1672,
    y1: 5.67896,
    x2: 29.1672,
    y2: 65.8152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47FFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FFBD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.1d1f719a09a1899ebed8cafb6ecbb92a.svg";
export { ForwardRef as ReactComponent };